module.exports = __webpack_public_path__ + "media/silence.2b5bb705.mp3";